import React, { useState } from "react";
import {
    useCreateCountryMutation,
    useUpdateCountryMutation,
} from "../Service/countriesApi";
import EntityFormLayout from "../../Shared/Components/EntityFormLayout/EntityFormLayout";

import { countryValues } from "../initialValues";
import { countryFields } from "../fields";
import { CountriesRoutes } from "../../../Router/path";
import PublicIcon from "@mui/icons-material/Public";
import InfoIcon from "@mui/icons-material/Info";
import SearchIcon from "@mui/icons-material/Search";
import SettingsIcon from "@mui/icons-material/Settings";
import AccordionCard from "../../Shared/Components/AccordionCard/AccordionCard";
import ImageIcon from "@mui/icons-material/Image";
import UploadImagesForm from "../../Shared/Components/UploadImagesForm/UploadImagesForm";
import { useUploadCountryImagesMutation } from "../Service/extendedCoutriesApi";
import { FormRenderGroupTypes } from "../../Shared/Components/FormRenderer/FormRenderGroup.types";
import { Typography } from "@mui/material";
import { useEntityForm } from '../../Shared/Hooks/useEntityForm';
import { extractCountryEntityFormApiErrors } from '../Utils/countryEntityFormApiErrorHandling';

const CreateCountry = () => {
    const [createCountry, createStatus] = useCreateCountryMutation();
    const [updateCountry, updateStatus] = useUpdateCountryMutation();
    const [uploadCountryImages, uploadState] = useUploadCountryImagesMutation();
    const [createdCountryId, setCreatedCountryId] = useState<number | null>(null);

    const mutationFn = createdCountryId ? updateCountry : createCountry;
    const mutationStatus = createdCountryId ? updateStatus : createStatus;

    const entityForm = useEntityForm({
        initialData: countryValues,
        fields: countryFields,
        submitFn: (data) => {
            const { name, description, published } = data;
            if (createdCountryId) {

                const updatePayload = {
                    id: createdCountryId,
                    name,
                    description,
                    published,
                    data: { name, description, published: published },
                };

                return mutationFn(updatePayload).unwrap();
            } else {
                const createPayload = {
                    ...data,
                    data: { name, description, published },
                };

                return mutationFn(createPayload).unwrap();
            }
        },
        redirectUrl: CountriesRoutes.root,
        title: createdCountryId ? "Edytuj kraj" : "Dodaj kraj",
        icon: <PublicIcon />,
        backUrl: CountriesRoutes.root,
        groupOrder: [
            FormRenderGroupTypes.basic,
            FormRenderGroupTypes.seo,
            FormRenderGroupTypes.configuration,
        ],
        groupIcons: {
            Podstawowe: <InfoIcon />,
            SEO: <SearchIcon />,
            Konfiguracja: <SettingsIcon />,
        },
        showSuccessBeforeRedirect: true,
        redirectDelay: 2000,
        onSuccessWithResponse: (response, shouldRedirect) => {
            if (!shouldRedirect && !createdCountryId) {
                setCreatedCountryId(response.countryId);
            }
        },
        mutationStatus,
        errorExtractor: extractCountryEntityFormApiErrors,
    });

    return (
        <EntityFormLayout {...entityForm}>
            <AccordionCard title="Zdjęcia" icon={<ImageIcon />}>
                {createdCountryId ? (
                    <UploadImagesForm
                        useUploadMutation={() => [uploadCountryImages, uploadState]}
                        mutationParams={(files) => ({ countryId: createdCountryId, files })}
                    />
                ) : (
                    <Typography color="text.secondary">
                        Zdjęcia możesz dodać dopiero po zapisaniu kraju.
                    </Typography>
                )}
            </AccordionCard>
        </EntityFormLayout>
    );
};

export default CreateCountry;
